import { useState, useEffect } from 'react';

export function useSessionStorageState<T>(key: string, defaultValue: T): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState<T>(() => {
    const savedValue = sessionStorage.getItem(key);
    if (savedValue !== null) {
      return JSON.parse(savedValue) as T;
    }
    return defaultValue;
  });

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
}
